import { inject, Injectable } from '@angular/core';
import { EntityService } from '../../core/services/entity.service';
import { ModuleLearningUnitMetadataEntity } from '../module-learning-unit-metadata.entity';
import { createEntityState, GenericEntityStateClass } from '../../core/state/entity.state';
import { LearningUnitEntityService } from '../../learning-unit/services/learning-unit.entity.service';

export const STATE_NAME = 'moduleLearningUnitMetadataEntity';

export const ModuleLearningUnitMetadataEntityState: GenericEntityStateClass<ModuleLearningUnitMetadataEntity> =
  createEntityState<ModuleLearningUnitMetadataEntity>(STATE_NAME);

@Injectable({ providedIn: 'root' })
export class ModuleLearningUnitMetadataEntityService extends EntityService<ModuleLearningUnitMetadataEntity> {
  private learningUnitService = inject(LearningUnitEntityService);

  constructor() {
    super();
    this.resourceType = 'module-learning-unit-metadata';
    this.stateClass = ModuleLearningUnitMetadataEntityState;

    this.registerRelation('learning-units', this.learningUnitService);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  allByQuery(query: Record<string, any> = {}) {
    const stateClass = this.stateClass;
    const sliceName = STATE_NAME;

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (storeState: any): ModuleLearningUnitMetadataEntity[] => {
      const slice = storeState[sliceName];
      return stateClass.allByQuery(slice, { query });
    };
  }
}
